export const ACCOUNT_LIST = [
    {
        ID:1,
        name: "Glasgow Taxis",
        companyName: "Glasgow Taxis",
        email:"glasgow@taxis.com",
        phone:"01414297070",
    },
    {
        ID:2,
        name: "Chris (installer)",
        companyName: "CubeWraps",
        email:"Chris@cubewraps.com",
        phone:"01698826946",
    },
    {
        ID: 6,
        name: "Lily pots",
        companyName: "lily pond",
        email: "lily.pond@lake.com",
        phone: "01698826946",
    },
    {
        ID:8,
        name: "Glasgow CSC",
        companyName: null,
        email:"glasgow@taxis.com",
        phone:"07518881967",
    },
    {
        ID:3,
        name: "Miquel",
        companyName: "Cafe Andaluz",
        email:"miquel@drg.com",
        phone:"01413391111",
    }, 
    {
        ID:7,
        name: "John Williamson",
        companyName: "Glasgow University",
        email:"johnwilliamson@glasgow.ac.uk",
        phone:"01413302000",
    },
    {
        ID:4,
        name: "Gary Wraps",
        companyName: "CubeWraps",
        email:"gary@cubewraps.com",
        phone:"01698826946",
    },
    {
        ID:5,
        name: "John Newton",
        companyName: "ParkerTowers",
        email:"josephnewtonparker@gmail.com",
        phone:"07563298092",
    },
    {
        ID:4,
        name: "Lucy Baird",
        companyName: "Baird Consulting",
        email:"Lucy.Baird@gmail.com",
        phone:"03700100222",
    },
    {
        ID:9,
        name: "John (installer)",
        companyName: "CubeWraps",
        email:"John@cubewraps.com",
        phone:"07692312456",
    },
    {
        ID:10,
        name: "Greg (installer)",
        companyName: "CubeWraps",
        email:"Greg@cubewraps.com",
        phone:"07563123000",
    },
    {
        ID:11,
        name: "Fiona (installer)",
        companyName: "CubeWraps",
        email:"Fiona@cubewraps.com",
        phone:"07644233531",
    },
    {
        ID:12,
        name: "Nicole (installer)",
        companyName: "CubeWraps",
        email:"Nicole@cubewraps.com",
        phone:"07893456727",
    },
    {
        ID:13,
        name: "Psyonix",
        companyName: "Psyonix",
        email:"advertising@psyonix.com",
        phone:null,
    },
    {
        ID:14,
        name: "Glasgow Tours",
        companyName: "Glasgow Tours",
        email:"glasgowtours@tourguides.com",
        phone:null,
    },
    {
        ID:15,
        name: "kevin white",
        companyName: "kevin plumbing",
        email:"kevin.white@gmail.com",
        phone:5550178,
    },
    {
        ID:16,
        name: "Jim Smith",
        companyName: null,
        email:"Jim.Smith@hotmail.com",
        phone:null,
    },
]